// Action Types
export const FETCH_ACC_CONTACTS_REQUEST = "FETCH_ACC_CONTACTS_REQUEST";
export const FETCH_ACC_CONTACTS_SUCCESS = "FETCH_ACC_CONTACTS_SUCCESS";
export const FETCH_ACC_CONTACTS_FAILURE = "FETCH_ACC_CONTACTS_FAILURE";

// Action Creators
export const fetchAccountContactRequest = (accountName) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_ACC_CONTACTS_REQUEST,
      payload: accountName,
    });
  };
};
export const fetchAccountContactSuccess = (data) => ({
  type: FETCH_ACC_CONTACTS_SUCCESS,
  payload: data,
});
export const fetchAccountContactFailure = (error) => ({
  type: FETCH_ACC_CONTACTS_FAILURE,
  payload: error,
});
